import type { PublicationItem } from 'components/discover/publications/model';
import { FormattedDate } from 'react-intl';
import styled from 'styled-components';

interface VideoPosterProps {
  item: PublicationItem;

  active: boolean;

  onPlay?: () => void;

  labels: string[];
}

const VideoPosterContainer = styled.div.attrs<{ $active: boolean }>({
  className: 'media-player card position-absolute w-100',
})`
  z-index: ${({ $active }) => ($active ? 999 : 998)};
  display: flex;
  animation: ${({ $active }) => ($active ? '500ms ease-out 0s appear' : '')};

  @keyframes appear {
    from {
      opacity: 0%;
    }
    to {
      opacity: 100%;
    }
  }
`;

const VideoPosterImage = styled.img.attrs({ className: 'd-flex flex-grow-1 card-img' })`
  object-fit: cover;
  aspect-ratio: 16 / 9;
`;

function VideoPoster({
  item: { title, imageUrl, videoId, publicationDate, id },
  active,
  onPlay,
  labels,
}: VideoPosterProps) {
  return (
    <VideoPosterContainer $active={active} key={id} role={active ? 'main' : 'presentation'}>
      <VideoPosterImage src={imageUrl ?? `https://socgen.qumucloud.com/kulu/${videoId}/thumbnail`} alt={title} />
      <div className="card-img-overlay bg-blur-gradient bg-dark bg-opacity-70"></div>
      <div className="card-img-overlay d-flex flex-column justify-content-end gap-3 p-0">
        <div className="card-caption p-4">
          <h2 className="card-title text-white mb-2 mb-md-3 w-50" role="caption">
            {title}
          </h2>
          <div className="flex-x gap-3">
            <button className="btn btn-white btn-xl btn-icon px-5 stretched-link" onClick={onPlay}>
              <i className="icon">play_arrow</i>
            </button>
            <div className="labels d-flex flex-grow-1 flex-column justify-content-around align-self-stretch">
              <div className="d-flex gap-2">
                {labels.map(label => (
                  <span key={label} className="badge badge-secondary">
                    {label}
                  </span>
                ))}
              </div>
              <span className="text-light">
                Published on <FormattedDate value={publicationDate} day="numeric" month="short" year="numeric" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </VideoPosterContainer>
  );
}

export { VideoPoster };
